/**
 * Proxy gratuito de imagens via images.weserv.nl.
 * Entrega WebP/AVIF automático, resize e cache global — sem custo.
 *
 * Não aplicar em:
 *  - data: URLs
 *  - assets já no weserv
 *  - assets locais do Vite (/assets/, começando com /)
 *  - CDN do Google Avatar (ele já serve WebP otimizado)
 */
export function proxyImage(
  url: string | null | undefined,
  opts: { w?: number; h?: number; q?: number } = {}
): string | null | undefined {
  if (!url) return url;
  if (url.startsWith("data:")) return url;
  // URL protocolo-relativa (ex.: //cdn.rede.com/logo.png) é externa: precisa do
  // proxy, senão herda http:// e vira conteúdo misto.
  if (url.startsWith("//")) url = `https:${url}`;
  else if (url.startsWith("/")) return url;
  if (url.includes("images.weserv.nl")) return url;
  if (url.includes("googleusercontent.com")) return url;

  // Supabase Storage: usar o transformer nativo (WebP + resize),
  // muito mais rápido que rebotar em weserv.
  const supaMatch = url.match(/(\.supabase\.co\/storage\/v1)\/object\/public\//);
  if (supaMatch) {
    const rendered = url.replace("/object/public/", "/render/image/public/");
    const params = new URLSearchParams({
      format: "webp",
      quality: String(opts.q ?? 75),
    });
    // O transformador do Storage usa "cover" por padrão e mantém a dimensão
    // que não foi informada, o que estica a imagem (ex.: 96x320).
    // Enviamos sempre as duas dimensões + resize=contain para preservar proporção.
    const w = opts.w ?? opts.h;
    const h = opts.h ?? opts.w;
    if (w && h) {
      params.set("width", String(w));
      params.set("height", String(h));
      params.set("resize", "contain");
    }
    return `${rendered}?${params.toString()}`;
  }

  const clean = url.replace(/^https?:\/\//, "");
  const params = new URLSearchParams({
    url: clean,
    output: "webp",
    q: String(opts.q ?? 80),
  });
  if (opts.w) params.set("w", String(opts.w));
  if (opts.h) params.set("h", String(opts.h));
  return `https://images.weserv.nl/?${params.toString()}`;
}